import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { RootState } from '../../store/store';
import { Div } from '../../framework';

import './RoleCard.scss';

type Props = {
  children: React.ReactNode;
};

const SkeletonRoleCard: FC<Props> = ({ children }) => {
  const { loadStack } = useSelector((state: RootState) => state.app);

  return loadStack.includes('job/role/list') ? (
    <Div className='skeleton-role-card'>
      <Div className='role-header'>
        <Skeleton
          width={200}
          height={20}
          baseColor='#ebebeb33'
          highlightColor='#f5f5f533'
        />
        <Skeleton
          width={100}
          height={10}
          baseColor='#ebebeb33'
          highlightColor='#f5f5f533'
        />
      </Div>
      {/* <Div flex className='role-summary'>
        <Div className='attribute'>
          <Text className='value'>30</Text>
          <Text className='label'>Total Applicants</Text>
        </Div>
        <Div className='attribute'>
          <Text className='value'>8</Text>
          <Text className='label'>Pending Actions</Text>
        </Div>
      </Div> */}
      <Div flex className='role-summary'>
        {/* <Div flex className='attribute'>
          <Skeleton width={30} height={20} />
          <Skeleton width={70} height={10} />
        </Div> */}
        <Div className='description'>
          <Skeleton width={200} height={10} />
          <Skeleton width={150} height={10} />
        </Div>
      </Div>
      <Div className='role-details'>
        <Div flex className='attribute'>
          <Div className='label'>
            <Skeleton width={70} height={10} />
          </Div>
          <Div className='value'>
            <Skeleton width={70} height={20} />
          </Div>
        </Div>
        <Div flex className='attribute'>
          <Div className='label'>
            <Skeleton width={80} height={10} />
          </Div>
          <Div className='value'>
            <Skeleton width={150} height={20} />
          </Div>
        </Div>
        <Div flex className='attribute'>
          <Div className='label'>
            <Skeleton width={90} height={10} />
          </Div>
          <Div className='value'>
            <Skeleton width={70} height={20} />
          </Div>
        </Div>
        <Div flex className='attribute'>
          <Div className='label'>
            <Skeleton width={40} height={10} />
          </Div>
          <Div className='value capitalize'>
            <Skeleton width={70} height={20} />
          </Div>
        </Div>
        <Div flex className='attribute'>
          <Div className='label'>
            <Skeleton width={120} height={10} />
          </Div>
          <Div className='value capitalize'>
            <Skeleton width={70} height={20} />
          </Div>
        </Div>
        <Div flex className='attribute'>
          <Div className='label'>
            <Skeleton width={90} height={10} />
          </Div>
          <Div className='value'>
            <Skeleton width={90} height={20} />
          </Div>
        </Div>
        <Div flex className='attribute'>
          <Div className='label'>
            <Skeleton width={110} height={10} />
          </Div>
          <Div className='value'>
            <Skeleton width={100} height={20} />
          </Div>
        </Div>
        <Div flex className='attribute'>
          <Div className='label'>
            <Skeleton width={80} height={10} />
          </Div>
          <Div className='value'>
            <Skeleton width={70} height={20} />
          </Div>
        </Div>
      </Div>
      <Div className='role-action' flex>
        <Div>
          <Skeleton width={70} height={15} />
        </Div>
        <Div>
          <Skeleton width={70} height={15} />
        </Div>
      </Div>
    </Div>
  ) : (
    <>{children}</>
  );
};

export default SkeletonRoleCard;
